(() => {
  const track = document.getElementById('hero-carousel-track');
  if (!track) return;

  const root = track.closest('.material-carousel') || document;
  const slides = [...track.querySelectorAll('.hero-carousel-slide')];
  const dots = [...root.querySelectorAll('.hero-carousel-dots button')];
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const firstSlideClone = slides[0].cloneNode(true);
  firstSlideClone.classList.add('is-carousel-clone');
  firstSlideClone.setAttribute('aria-hidden', 'true');
  firstSlideClone.querySelector('img').alt = '';
  track.appendChild(firstSlideClone);
  let activeIndex = 0;
  let scrollFrame = 0;
  let settleTimer = 0;
  let paused = false;

  function setActive(index) {
    activeIndex = index;
    dots.forEach((dot, dotIndex) => {
      if (dotIndex === index) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }

  function goTo(index) {
    const nextIndex = index >= slides.length || (index === 0 && activeIndex === slides.length - 1)
      ? slides.length
      : (index + slides.length) % slides.length;
    setActive(nextIndex === slides.length ? 0 : nextIndex);
    track.scrollTo({
      left: (nextIndex === slides.length ? firstSlideClone : slides[nextIndex]).offsetLeft - slides[0].offsetLeft,
      behavior: reducedMotion.matches ? 'instant' : 'smooth',
    });
  }

  function resetFromClone() {
    const cloneOffset = firstSlideClone.offsetLeft - slides[0].offsetLeft;
    if (Math.abs(track.scrollLeft - cloneOffset) > 2) return;
    track.style.scrollSnapType = 'none';
    track.style.scrollBehavior = 'auto';
    track.scrollLeft = 0;
    setActive(0);
    requestAnimationFrame(() => {
      track.style.scrollSnapType = '';
      track.style.scrollBehavior = '';
    });
  }

  dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index)));
  root.querySelector('[data-carousel-prev]')?.addEventListener('click', () => goTo(activeIndex - 1));
  root.querySelector('[data-carousel-next]')?.addEventListener('click', () => goTo(activeIndex + 1));
  const pauseTarget = root === document ? track : root;
  pauseTarget.addEventListener('pointerenter', () => { paused = true; });
  pauseTarget.addEventListener('pointerleave', () => { paused = false; });
  pauseTarget.addEventListener('focusin', () => { paused = true; });
  pauseTarget.addEventListener('focusout', () => { paused = false; });
  track.addEventListener('keydown', event => {
    if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
    event.preventDefault();
    goTo(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
  });
  track.addEventListener('scroll', () => {
    cancelAnimationFrame(scrollFrame);
    scrollFrame = requestAnimationFrame(() => {
      const index = Math.round(track.scrollLeft / track.clientWidth);
      setActive(index >= slides.length ? 0 : Math.max(0, index));
    });
    clearTimeout(settleTimer);
    settleTimer = setTimeout(resetFromClone, 150);
  }, { passive: true });
  track.addEventListener('scrollend', resetFromClone);
  setInterval(() => {
    if (!paused && !document.hidden && !reducedMotion.matches) goTo(activeIndex + 1);
  }, 5000);
})();
